export const meta = {
  title: 'Frequently asked questions',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'troubleshooting'],
};

The questions operators actually ask, with short answers. Every one links back to a fuller article in this manual.

## How long does it take to go live?

Minutes. Signup is four fields and no card, the welcome wizard sets up your outlet, hours, and logo, and **Print QR** gives you the code your customers scan. The full walk-through is in _Getting started_. Your first 14 days are a free trial with full access.

## Do my customers have to download an app?

No. They scan your QR and your app opens in their browser — no app store, no download. They _can_ add it to their home screen so it behaves like an installed app, but everything works either way.

## Whose name do customers see — mine or the network's?

Yours. Your name, your logo, your colours. The network appears only as a small "part of the network" line. See _Branding_.

## What happens when my trial ends?

Your plan starts billing monthly, in arrears: one invoice lands shortly after the 1st covering the month just ended, and you pay it by FPX from the Billing page. Every charge is itemised — see _Billing & your subscription_.

## Can I run several outlets under one account?

Yes. Add outlets from the Outlets page; each gets its own queue and QR code, and the prorated charge is previewed before you confirm. Staff can be scoped per outlet.

## Do walk-in customers earn loyalty points?

Only signed-in customers earn points — a walk-in ticket with no customer account earns nothing. That's the best reason to nudge regulars to scan your QR. See _Loyalty_.

## Why did my broadcast reach fewer people than I have customers?

Three protective gates: marketing opt-outs, quiet hours, and customers who never allowed notifications. The send summary names every bucket so the gap is never a mystery. See _Marketing broadcasts_.

## Does using an agent code cost me anything?

No. Prices are identical with or without one. The agent earns a one-time commission per signup from the network's side — never from your bill. See _Agent codes & referrals_.

## Can customers see my prices without booking?

Yes — your packages, add-ons, and prices are public in your app. Anyone with your link or QR can browse the catalog before deciding.

## Which languages does the platform speak?

The dashboard, your customer app, and this manual run in English, Bahasa Melayu, 中文, and தமிழ் — customers pick their language in the app. One honest gap: push notification wording is currently fixed English. See _Notifications_.

## Do my staff each get their own login?

Yes. Invite them by phone number from the Staff page and they sign in with a one-time code — no passwords to manage. Roles (manager, cashier, washer) control exactly what each person can touch. See _Staff & roles_.

## How do I get onto the public find directory?

Flip **Show my outlets on the public directory** at the bottom of the Hours page. It's off by default — nobody is listed without choosing it. If you've flipped it and still don't appear, _Troubleshooting_ has the checklist.
